export const DISCOUNT_HEIGHT = 40;
export const DISCOUNT_WIDTH = 40;
export const COUPON_EXPIRED = 'Coupon expired';
export const OFFER_EXPIRED = 'Offer expired';
export const ICON_SIZES = {
  LOCK_ICON_SIZE: '24px',
  COPY_ICON_SIZE: '16px'  
};

//EXPIRY_THRESHOLD_TIME signifies the number of milliseconds in 12h.
export const EXPIRY_THRESHOLD_TIME = 43200000;
export const VIEW_PRODUCTS = "View Products";

export const COUPON_ACTION_TYPE = {
    APPLY: 'apply',
    COPY: 'copy',
    VIEW_PRODUCT: 'viewProduct',
  };